import text from './text';
import mutation from './mutation';
import disable from './disable';

export default {
  text,
  mutation,
  disable,
};
